import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { LOGIN_TYPES } from 'src/app/modules/login/models/login-types';
import { environment } from 'src/environments/environment';
import { LOCAL_STORAGE_KEYS } from '../models/local-storage-keys';
import { LoggedUserService } from './logged-user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly url = `${environment.apiUrl}`;

  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    private _oAuthService: OAuthService,
    private loggedUserService: LoggedUserService,
  ) { }

  public login(userData: {
    username: string;
    password: string;
  }): Observable<any> {
    let loginUrl = this.url + (this.isInternalLoggedIn() ? 'login' : 'external/login');
    return this._httpClient.post(loginUrl, userData);
  }

  public closeSession() {
    let externalUser: boolean = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE) === LOGIN_TYPES.EXTERNAL;
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_NAME);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT_URL);
    if (
      Object.is(
        LOGIN_TYPES.OAUTH,
        localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE)
      )
    ) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.IS_LOGIN_LAST_ACTION);
      this._oAuthService.logOut();
    }
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE);
    this.loggedUserService.logoutUser();
    sessionStorage.clear();
    localStorage.clear();
    if (externalUser) {
      this._router.navigate(['/loginext']);
    } else {
      this._router.navigate(['/login']);
    }
  }

  public isLoggedIn(): boolean {
    if (
      LOGIN_TYPES.OAUTH ===
      localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE)
    ) {
      return this.isOAuthLoggedIn();
    } else {
      return this.isInternalLoggedIn();
    }
  }

  private isOAuthLoggedIn(): boolean {
    if (this._oAuthService.hasValidIdToken()) {
      return true;
    }
    return false;
  }

  private isInternalLoggedIn(): boolean {
    const token: string = localStorage.getItem(
      LOCAL_STORAGE_KEYS.AUTH_TOKEN
    );
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  public getRedirectLoginUrl(): string {
    return (
      localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT_URL) ?? ''
    );
  }

  public setRedirectLoginUrl(url: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT_URL, url);
  }

  public recovery(dto: any): Observable<any> {
    let loginUrl = this.url + 'external/recovery';
    return this._httpClient.post(loginUrl, dto);
  }

  public recoveryPassword(password: string): Observable<any> {
    let loginUrl = this.url + 'recovery/password';
    return this._httpClient.post(loginUrl, password);
  }
}
